/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StiDto } from '../../models/sti-dto';

export interface GetStiById$Params {
  idSti: string;
}

export function getStiById(
  http: HttpClient,
  rootUrl: string,
  params: GetStiById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<StiDto>> {
  const rb = new RequestBuilder(rootUrl, getStiById.PATH, 'get');
  if (params) {
    rb.path('idSti', params.idSti, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StiDto>;
    })
  );
}

getStiById.PATH = '/v2/stis/{idSti}';
